/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MsalRedirectRouteImport } from './routes/msal-redirect'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as EncryptedNameRouteImport } from './routes/$encryptedName'
import { Route as StoriesRouteRouteImport } from './routes/stories/route'
import { Route as PlaygroundRouteRouteImport } from './routes/playground/route'
import { Route as EmbedRouteRouteImport } from './routes/embed/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as StoriesIndexRouteImport } from './routes/stories/index'
import { Route as OnBoardingIndexRouteImport } from './routes/on-boarding/index'
import { Route as FormBuilderIndexRouteImport } from './routes/form-builder/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as WorkflowBuilderWorkflowIdRouteImport } from './routes/workflow-builder/$workflowId'
import { Route as StoriesTypographyRouteImport } from './routes/stories/typography'
import { Route as StoriesTooltipRouteImport } from './routes/stories/tooltip'
import { Route as StoriesToastRouteImport } from './routes/stories/toast'
import { Route as StoriesTabsRouteImport } from './routes/stories/tabs'
import { Route as StoriesTableRouteImport } from './routes/stories/table'
import { Route as StoriesStepperRouteImport } from './routes/stories/stepper'
import { Route as StoriesSkeletonRouteImport } from './routes/stories/skeleton'
import { Route as StoriesScrollAreaRouteImport } from './routes/stories/scroll-area'
import { Route as StoriesPopoverRouteImport } from './routes/stories/popover'
import { Route as StoriesPaginationRouteImport } from './routes/stories/pagination'
import { Route as StoriesModalRouteImport } from './routes/stories/modal'
import { Route as StoriesMenuRouteImport } from './routes/stories/menu'
import { Route as StoriesInputTimeRouteImport } from './routes/stories/input-time'
import { Route as StoriesInputTextareaRouteImport } from './routes/stories/input-textarea'
import { Route as StoriesInputTextRouteImport } from './routes/stories/input-text'
import { Route as StoriesInputSwitchGroupRouteImport } from './routes/stories/input-switch-group'
import { Route as StoriesInputSwitchRouteImport } from './routes/stories/input-switch'
import { Route as StoriesInputSelectMultipleRouteImport } from './routes/stories/input-select-multiple'
import { Route as StoriesInputSelectRouteImport } from './routes/stories/input-select'
import { Route as StoriesInputRadioGroupRouteImport } from './routes/stories/input-radio-group'
import { Route as StoriesInputRadioCardRouteImport } from './routes/stories/input-radio-card'
import { Route as StoriesInputRadioRouteImport } from './routes/stories/input-radio'
import { Route as StoriesInputPinRouteImport } from './routes/stories/input-pin'
import { Route as StoriesInputPasswordRouteImport } from './routes/stories/input-password'
import { Route as StoriesInputNumberRouteImport } from './routes/stories/input-number'
import { Route as StoriesInputDateTimeRouteImport } from './routes/stories/input-date-time'
import { Route as StoriesInputDateRouteImport } from './routes/stories/input-date'
import { Route as StoriesInputCheckboxGroupRouteImport } from './routes/stories/input-checkbox-group'
import { Route as StoriesInputCheckboxCardRouteImport } from './routes/stories/input-checkbox-card'
import { Route as StoriesInputCheckboxRouteImport } from './routes/stories/input-checkbox'
import { Route as StoriesIndicatorRouteImport } from './routes/stories/indicator'
import { Route as StoriesIconButtonRouteImport } from './routes/stories/icon-button'
import { Route as StoriesHighlightRouteImport } from './routes/stories/highlight'
import { Route as StoriesFormRouteImport } from './routes/stories/form'
import { Route as StoriesEmptyStateRouteImport } from './routes/stories/empty-state'
import { Route as StoriesDrawerRouteImport } from './routes/stories/drawer'
import { Route as StoriesDividerRouteImport } from './routes/stories/divider'
import { Route as StoriesDataTableRouteImport } from './routes/stories/data-table'
import { Route as StoriesColorsRouteImport } from './routes/stories/colors'
import { Route as StoriesCardRouteImport } from './routes/stories/card'
import { Route as StoriesButtonRouteImport } from './routes/stories/button'
import { Route as StoriesBarLoaderRouteImport } from './routes/stories/bar-loader'
import { Route as StoriesBadgeRouteImport } from './routes/stories/badge'
import { Route as StoriesAvatarRouteImport } from './routes/stories/avatar'
import { Route as StoriesAiIconRouteImport } from './routes/stories/ai-icon'
import { Route as StoriesAccordionRouteImport } from './routes/stories/accordion'
import { Route as StoriesAlertRouteImport } from './routes/stories/Alert'
import { Route as SignRequestSplatRouteImport } from './routes/sign-request/$'
import { Route as PortalsPortalIdRouteImport } from './routes/portals_.$portalId'
import { Route as PortalPortalIdRouteImport } from './routes/portal/$portalId'
import { Route as OnBoardingTokenRouteImport } from './routes/on-boarding/$token'
import { Route as FormBuilderFormIdRouteImport } from './routes/form-builder/$formId'
import { Route as EmbedRequestsRouteImport } from './routes/embed/requests'
import { Route as EmbedFoldersRouteImport } from './routes/embed/folders'
import { Route as EmbedDashboardRouteImport } from './routes/embed/dashboard'
import { Route as AppWorkflowsRouteImport } from './routes/_app/workflows'
import { Route as AppWorkflowChatRouteImport } from './routes/_app/workflow-chat'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppRequestsRouteImport } from './routes/_app/requests'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppPortalsRouteImport } from './routes/_app/portals'
import { Route as AppMobilePreviewRouteImport } from './routes/_app/mobile-preview'
import { Route as AppHelpCenterRouteImport } from './routes/_app/help-center'
import { Route as AppFormsRouteImport } from './routes/_app/forms'
import { Route as AppFoldersRouteImport } from './routes/_app/folders'
import { Route as AuthSignUpIndexRouteImport } from './routes/_auth/sign-up/index'
import { Route as AuthSignInIndexRouteImport } from './routes/_auth/sign-in/index'
import { Route as AuthSetupIndexRouteImport } from './routes/_auth/setup/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/_auth/reset-password/index'
import { Route as AuthRecoverIndexRouteImport } from './routes/_auth/recover/index'
import { Route as AuthNewuserIndexRouteImport } from './routes/_auth/newuser/index'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password/index'
import { Route as PortalsTenantIdPortalIdRouteImport } from './routes/portals_.$tenantId.$portalId'
import { Route as AppReportsReportIdRouteImport } from './routes/_app/reports_.$reportId'
import { Route as AppMyAccountChar123SlugChar125RouteImport } from './routes/_app/my-account.{-$slug}'
import { Route as AppFormsFormIdEntriesRouteImport } from './routes/_app/forms_.$formId.entries'

const MsalRedirectRoute = MsalRedirectRouteImport.update({
  id: '/msal-redirect',
  path: '/msal-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const EncryptedNameRoute = EncryptedNameRouteImport.update({
  id: '/$encryptedName',
  path: '/$encryptedName',
  getParentRoute: () => rootRouteImport,
} as any)
const StoriesRouteRoute = StoriesRouteRouteImport.update({
  id: '/stories',
  path: '/stories',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRouteRoute = PlaygroundRouteRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedRouteRoute = EmbedRouteRouteImport.update({
  id: '/embed',
  path: '/embed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const StoriesIndexRoute = StoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const OnBoardingIndexRoute = OnBoardingIndexRouteImport.update({
  id: '/on-boarding/',
  path: '/on-boarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormBuilderIndexRoute = FormBuilderIndexRouteImport.update({
  id: '/form-builder/',
  path: '/form-builder/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const WorkflowBuilderWorkflowIdRoute =
  WorkflowBuilderWorkflowIdRouteImport.update({
    id: '/workflow-builder/$workflowId',
    path: '/workflow-builder/$workflowId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StoriesTypographyRoute = StoriesTypographyRouteImport.update({
  id: '/typography',
  path: '/typography',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesTooltipRoute = StoriesTooltipRouteImport.update({
  id: '/tooltip',
  path: '/tooltip',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesToastRoute = StoriesToastRouteImport.update({
  id: '/toast',
  path: '/toast',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesTabsRoute = StoriesTabsRouteImport.update({
  id: '/tabs',
  path: '/tabs',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesTableRoute = StoriesTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesStepperRoute = StoriesStepperRouteImport.update({
  id: '/stepper',
  path: '/stepper',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesSkeletonRoute = StoriesSkeletonRouteImport.update({
  id: '/skeleton',
  path: '/skeleton',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesScrollAreaRoute = StoriesScrollAreaRouteImport.update({
  id: '/scroll-area',
  path: '/scroll-area',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesPopoverRoute = StoriesPopoverRouteImport.update({
  id: '/popover',
  path: '/popover',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesPaginationRoute = StoriesPaginationRouteImport.update({
  id: '/pagination',
  path: '/pagination',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesModalRoute = StoriesModalRouteImport.update({
  id: '/modal',
  path: '/modal',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesMenuRoute = StoriesMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputTimeRoute = StoriesInputTimeRouteImport.update({
  id: '/input-time',
  path: '/input-time',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputTextareaRoute = StoriesInputTextareaRouteImport.update({
  id: '/input-textarea',
  path: '/input-textarea',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputTextRoute = StoriesInputTextRouteImport.update({
  id: '/input-text',
  path: '/input-text',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputSwitchGroupRoute = StoriesInputSwitchGroupRouteImport.update({
  id: '/input-switch-group',
  path: '/input-switch-group',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputSwitchRoute = StoriesInputSwitchRouteImport.update({
  id: '/input-switch',
  path: '/input-switch',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputSelectMultipleRoute =
  StoriesInputSelectMultipleRouteImport.update({
    id: '/input-select-multiple',
    path: '/input-select-multiple',
    getParentRoute: () => StoriesRouteRoute,
  } as any)
const StoriesInputSelectRoute = StoriesInputSelectRouteImport.update({
  id: '/input-select',
  path: '/input-select',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputRadioGroupRoute = StoriesInputRadioGroupRouteImport.update({
  id: '/input-radio-group',
  path: '/input-radio-group',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputRadioCardRoute = StoriesInputRadioCardRouteImport.update({
  id: '/input-radio-card',
  path: '/input-radio-card',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputRadioRoute = StoriesInputRadioRouteImport.update({
  id: '/input-radio',
  path: '/input-radio',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputPinRoute = StoriesInputPinRouteImport.update({
  id: '/input-pin',
  path: '/input-pin',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputPasswordRoute = StoriesInputPasswordRouteImport.update({
  id: '/input-password',
  path: '/input-password',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputNumberRoute = StoriesInputNumberRouteImport.update({
  id: '/input-number',
  path: '/input-number',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputDateTimeRoute = StoriesInputDateTimeRouteImport.update({
  id: '/input-date-time',
  path: '/input-date-time',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputDateRoute = StoriesInputDateRouteImport.update({
  id: '/input-date',
  path: '/input-date',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesInputCheckboxGroupRoute =
  StoriesInputCheckboxGroupRouteImport.update({
    id: '/input-checkbox-group',
    path: '/input-checkbox-group',
    getParentRoute: () => StoriesRouteRoute,
  } as any)
const StoriesInputCheckboxCardRoute =
  StoriesInputCheckboxCardRouteImport.update({
    id: '/input-checkbox-card',
    path: '/input-checkbox-card',
    getParentRoute: () => StoriesRouteRoute,
  } as any)
const StoriesInputCheckboxRoute = StoriesInputCheckboxRouteImport.update({
  id: '/input-checkbox',
  path: '/input-checkbox',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesIndicatorRoute = StoriesIndicatorRouteImport.update({
  id: '/indicator',
  path: '/indicator',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesIconButtonRoute = StoriesIconButtonRouteImport.update({
  id: '/icon-button',
  path: '/icon-button',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesHighlightRoute = StoriesHighlightRouteImport.update({
  id: '/highlight',
  path: '/highlight',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesFormRoute = StoriesFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesEmptyStateRoute = StoriesEmptyStateRouteImport.update({
  id: '/empty-state',
  path: '/empty-state',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesDrawerRoute = StoriesDrawerRouteImport.update({
  id: '/drawer',
  path: '/drawer',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesDividerRoute = StoriesDividerRouteImport.update({
  id: '/divider',
  path: '/divider',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesDataTableRoute = StoriesDataTableRouteImport.update({
  id: '/data-table',
  path: '/data-table',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesColorsRoute = StoriesColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesCardRoute = StoriesCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesButtonRoute = StoriesButtonRouteImport.update({
  id: '/button',
  path: '/button',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesBarLoaderRoute = StoriesBarLoaderRouteImport.update({
  id: '/bar-loader',
  path: '/bar-loader',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesBadgeRoute = StoriesBadgeRouteImport.update({
  id: '/badge',
  path: '/badge',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesAvatarRoute = StoriesAvatarRouteImport.update({
  id: '/avatar',
  path: '/avatar',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesAiIconRoute = StoriesAiIconRouteImport.update({
  id: '/ai-icon',
  path: '/ai-icon',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesAccordionRoute = StoriesAccordionRouteImport.update({
  id: '/accordion',
  path: '/accordion',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const StoriesAlertRoute = StoriesAlertRouteImport.update({
  id: '/Alert',
  path: '/Alert',
  getParentRoute: () => StoriesRouteRoute,
} as any)
const SignRequestSplatRoute = SignRequestSplatRouteImport.update({
  id: '/sign-request/$',
  path: '/sign-request/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalsPortalIdRoute = PortalsPortalIdRouteImport.update({
  id: '/portals_/$portalId',
  path: '/portals/$portalId',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalPortalIdRoute = PortalPortalIdRouteImport.update({
  id: '/portal/$portalId',
  path: '/portal/$portalId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnBoardingTokenRoute = OnBoardingTokenRouteImport.update({
  id: '/on-boarding/$token',
  path: '/on-boarding/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const FormBuilderFormIdRoute = FormBuilderFormIdRouteImport.update({
  id: '/form-builder/$formId',
  path: '/form-builder/$formId',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedRequestsRoute = EmbedRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => EmbedRouteRoute,
} as any)
const EmbedFoldersRoute = EmbedFoldersRouteImport.update({
  id: '/folders',
  path: '/folders',
  getParentRoute: () => EmbedRouteRoute,
} as any)
const EmbedDashboardRoute = EmbedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => EmbedRouteRoute,
} as any)
const AppWorkflowsRoute = AppWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppWorkflowChatRoute = AppWorkflowChatRouteImport.update({
  id: '/workflow-chat',
  path: '/workflow-chat',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRequestsRoute = AppRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPortalsRoute = AppPortalsRouteImport.update({
  id: '/portals',
  path: '/portals',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMobilePreviewRoute = AppMobilePreviewRouteImport.update({
  id: '/mobile-preview',
  path: '/mobile-preview',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHelpCenterRoute = AppHelpCenterRouteImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFormsRoute = AppFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFoldersRoute = AppFoldersRouteImport.update({
  id: '/folders',
  path: '/folders',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSetupIndexRoute = AuthSetupIndexRouteImport.update({
  id: '/setup/',
  path: '/setup/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRecoverIndexRoute = AuthRecoverIndexRouteImport.update({
  id: '/recover/',
  path: '/recover/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthNewuserIndexRoute = AuthNewuserIndexRouteImport.update({
  id: '/newuser/',
  path: '/newuser/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const PortalsTenantIdPortalIdRoute = PortalsTenantIdPortalIdRouteImport.update({
  id: '/portals_/$tenantId/$portalId',
  path: '/portals/$tenantId/$portalId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppReportsReportIdRoute = AppReportsReportIdRouteImport.update({
  id: '/reports_/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMyAccountChar123SlugChar125Route =
  AppMyAccountChar123SlugChar125RouteImport.update({
    id: '/my-account/{-$slug}',
    path: '/my-account/{-$slug}',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppFormsFormIdEntriesRoute = AppFormsFormIdEntriesRouteImport.update({
  id: '/forms_/$formId/entries',
  path: '/forms/$formId/entries',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/embed': typeof EmbedRouteRouteWithChildren
  '/playground': typeof PlaygroundRouteRoute
  '/stories': typeof StoriesRouteRouteWithChildren
  '/$encryptedName': typeof EncryptedNameRoute
  '/auth': typeof AuthRoute
  '/msal-redirect': typeof MsalRedirectRoute
  '/folders': typeof AppFoldersRoute
  '/forms': typeof AppFormsRoute
  '/help-center': typeof AppHelpCenterRoute
  '/mobile-preview': typeof AppMobilePreviewRoute
  '/portals': typeof AppPortalsRoute
  '/reports': typeof AppReportsRoute
  '/requests': typeof AppRequestsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/trash': typeof AppTrashRoute
  '/workflow-chat': typeof AppWorkflowChatRoute
  '/workflows': typeof AppWorkflowsRoute
  '/embed/dashboard': typeof EmbedDashboardRoute
  '/embed/folders': typeof EmbedFoldersRoute
  '/embed/requests': typeof EmbedRequestsRoute
  '/form-builder/$formId': typeof FormBuilderFormIdRoute
  '/on-boarding/$token': typeof OnBoardingTokenRoute
  '/portal/$portalId': typeof PortalPortalIdRoute
  '/portals/$portalId': typeof PortalsPortalIdRoute
  '/sign-request/$': typeof SignRequestSplatRoute
  '/stories/Alert': typeof StoriesAlertRoute
  '/stories/accordion': typeof StoriesAccordionRoute
  '/stories/ai-icon': typeof StoriesAiIconRoute
  '/stories/avatar': typeof StoriesAvatarRoute
  '/stories/badge': typeof StoriesBadgeRoute
  '/stories/bar-loader': typeof StoriesBarLoaderRoute
  '/stories/button': typeof StoriesButtonRoute
  '/stories/card': typeof StoriesCardRoute
  '/stories/colors': typeof StoriesColorsRoute
  '/stories/data-table': typeof StoriesDataTableRoute
  '/stories/divider': typeof StoriesDividerRoute
  '/stories/drawer': typeof StoriesDrawerRoute
  '/stories/empty-state': typeof StoriesEmptyStateRoute
  '/stories/form': typeof StoriesFormRoute
  '/stories/highlight': typeof StoriesHighlightRoute
  '/stories/icon-button': typeof StoriesIconButtonRoute
  '/stories/indicator': typeof StoriesIndicatorRoute
  '/stories/input-checkbox': typeof StoriesInputCheckboxRoute
  '/stories/input-checkbox-card': typeof StoriesInputCheckboxCardRoute
  '/stories/input-checkbox-group': typeof StoriesInputCheckboxGroupRoute
  '/stories/input-date': typeof StoriesInputDateRoute
  '/stories/input-date-time': typeof StoriesInputDateTimeRoute
  '/stories/input-number': typeof StoriesInputNumberRoute
  '/stories/input-password': typeof StoriesInputPasswordRoute
  '/stories/input-pin': typeof StoriesInputPinRoute
  '/stories/input-radio': typeof StoriesInputRadioRoute
  '/stories/input-radio-card': typeof StoriesInputRadioCardRoute
  '/stories/input-radio-group': typeof StoriesInputRadioGroupRoute
  '/stories/input-select': typeof StoriesInputSelectRoute
  '/stories/input-select-multiple': typeof StoriesInputSelectMultipleRoute
  '/stories/input-switch': typeof StoriesInputSwitchRoute
  '/stories/input-switch-group': typeof StoriesInputSwitchGroupRoute
  '/stories/input-text': typeof StoriesInputTextRoute
  '/stories/input-textarea': typeof StoriesInputTextareaRoute
  '/stories/input-time': typeof StoriesInputTimeRoute
  '/stories/menu': typeof StoriesMenuRoute
  '/stories/modal': typeof StoriesModalRoute
  '/stories/pagination': typeof StoriesPaginationRoute
  '/stories/popover': typeof StoriesPopoverRoute
  '/stories/scroll-area': typeof StoriesScrollAreaRoute
  '/stories/skeleton': typeof StoriesSkeletonRoute
  '/stories/stepper': typeof StoriesStepperRoute
  '/stories/table': typeof StoriesTableRoute
  '/stories/tabs': typeof StoriesTabsRoute
  '/stories/toast': typeof StoriesToastRoute
  '/stories/tooltip': typeof StoriesTooltipRoute
  '/stories/typography': typeof StoriesTypographyRoute
  '/workflow-builder/$workflowId': typeof WorkflowBuilderWorkflowIdRoute
  '/': typeof AppIndexRoute
  '/form-builder': typeof FormBuilderIndexRoute
  '/on-boarding': typeof OnBoardingIndexRoute
  '/stories/': typeof StoriesIndexRoute
  '/my-account/{-$slug}': typeof AppMyAccountChar123SlugChar125Route
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/portals/$tenantId/$portalId': typeof PortalsTenantIdPortalIdRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/newuser': typeof AuthNewuserIndexRoute
  '/recover': typeof AuthRecoverIndexRoute
  '/reset-password': typeof AuthResetPasswordIndexRoute
  '/setup': typeof AuthSetupIndexRoute
  '/sign-in': typeof AuthSignInIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/forms/$formId/entries': typeof AppFormsFormIdEntriesRoute
}
export interface FileRoutesByTo {
  '/embed': typeof EmbedRouteRouteWithChildren
  '/playground': typeof PlaygroundRouteRoute
  '/$encryptedName': typeof EncryptedNameRoute
  '/auth': typeof AuthRoute
  '/msal-redirect': typeof MsalRedirectRoute
  '/folders': typeof AppFoldersRoute
  '/forms': typeof AppFormsRoute
  '/help-center': typeof AppHelpCenterRoute
  '/mobile-preview': typeof AppMobilePreviewRoute
  '/portals': typeof AppPortalsRoute
  '/reports': typeof AppReportsRoute
  '/requests': typeof AppRequestsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/trash': typeof AppTrashRoute
  '/workflow-chat': typeof AppWorkflowChatRoute
  '/workflows': typeof AppWorkflowsRoute
  '/embed/dashboard': typeof EmbedDashboardRoute
  '/embed/folders': typeof EmbedFoldersRoute
  '/embed/requests': typeof EmbedRequestsRoute
  '/form-builder/$formId': typeof FormBuilderFormIdRoute
  '/on-boarding/$token': typeof OnBoardingTokenRoute
  '/portal/$portalId': typeof PortalPortalIdRoute
  '/portals/$portalId': typeof PortalsPortalIdRoute
  '/sign-request/$': typeof SignRequestSplatRoute
  '/stories/Alert': typeof StoriesAlertRoute
  '/stories/accordion': typeof StoriesAccordionRoute
  '/stories/ai-icon': typeof StoriesAiIconRoute
  '/stories/avatar': typeof StoriesAvatarRoute
  '/stories/badge': typeof StoriesBadgeRoute
  '/stories/bar-loader': typeof StoriesBarLoaderRoute
  '/stories/button': typeof StoriesButtonRoute
  '/stories/card': typeof StoriesCardRoute
  '/stories/colors': typeof StoriesColorsRoute
  '/stories/data-table': typeof StoriesDataTableRoute
  '/stories/divider': typeof StoriesDividerRoute
  '/stories/drawer': typeof StoriesDrawerRoute
  '/stories/empty-state': typeof StoriesEmptyStateRoute
  '/stories/form': typeof StoriesFormRoute
  '/stories/highlight': typeof StoriesHighlightRoute
  '/stories/icon-button': typeof StoriesIconButtonRoute
  '/stories/indicator': typeof StoriesIndicatorRoute
  '/stories/input-checkbox': typeof StoriesInputCheckboxRoute
  '/stories/input-checkbox-card': typeof StoriesInputCheckboxCardRoute
  '/stories/input-checkbox-group': typeof StoriesInputCheckboxGroupRoute
  '/stories/input-date': typeof StoriesInputDateRoute
  '/stories/input-date-time': typeof StoriesInputDateTimeRoute
  '/stories/input-number': typeof StoriesInputNumberRoute
  '/stories/input-password': typeof StoriesInputPasswordRoute
  '/stories/input-pin': typeof StoriesInputPinRoute
  '/stories/input-radio': typeof StoriesInputRadioRoute
  '/stories/input-radio-card': typeof StoriesInputRadioCardRoute
  '/stories/input-radio-group': typeof StoriesInputRadioGroupRoute
  '/stories/input-select': typeof StoriesInputSelectRoute
  '/stories/input-select-multiple': typeof StoriesInputSelectMultipleRoute
  '/stories/input-switch': typeof StoriesInputSwitchRoute
  '/stories/input-switch-group': typeof StoriesInputSwitchGroupRoute
  '/stories/input-text': typeof StoriesInputTextRoute
  '/stories/input-textarea': typeof StoriesInputTextareaRoute
  '/stories/input-time': typeof StoriesInputTimeRoute
  '/stories/menu': typeof StoriesMenuRoute
  '/stories/modal': typeof StoriesModalRoute
  '/stories/pagination': typeof StoriesPaginationRoute
  '/stories/popover': typeof StoriesPopoverRoute
  '/stories/scroll-area': typeof StoriesScrollAreaRoute
  '/stories/skeleton': typeof StoriesSkeletonRoute
  '/stories/stepper': typeof StoriesStepperRoute
  '/stories/table': typeof StoriesTableRoute
  '/stories/tabs': typeof StoriesTabsRoute
  '/stories/toast': typeof StoriesToastRoute
  '/stories/tooltip': typeof StoriesTooltipRoute
  '/stories/typography': typeof StoriesTypographyRoute
  '/workflow-builder/$workflowId': typeof WorkflowBuilderWorkflowIdRoute
  '/': typeof AppIndexRoute
  '/form-builder': typeof FormBuilderIndexRoute
  '/on-boarding': typeof OnBoardingIndexRoute
  '/stories': typeof StoriesIndexRoute
  '/my-account/{-$slug}': typeof AppMyAccountChar123SlugChar125Route
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/portals/$tenantId/$portalId': typeof PortalsTenantIdPortalIdRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/newuser': typeof AuthNewuserIndexRoute
  '/recover': typeof AuthRecoverIndexRoute
  '/reset-password': typeof AuthResetPasswordIndexRoute
  '/setup': typeof AuthSetupIndexRoute
  '/sign-in': typeof AuthSignInIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/forms/$formId/entries': typeof AppFormsFormIdEntriesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/embed': typeof EmbedRouteRouteWithChildren
  '/playground': typeof PlaygroundRouteRoute
  '/stories': typeof StoriesRouteRouteWithChildren
  '/$encryptedName': typeof EncryptedNameRoute
  '/auth': typeof AuthRoute
  '/msal-redirect': typeof MsalRedirectRoute
  '/_app/folders': typeof AppFoldersRoute
  '/_app/forms': typeof AppFormsRoute
  '/_app/help-center': typeof AppHelpCenterRoute
  '/_app/mobile-preview': typeof AppMobilePreviewRoute
  '/_app/portals': typeof AppPortalsRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/requests': typeof AppRequestsRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/trash': typeof AppTrashRoute
  '/_app/workflow-chat': typeof AppWorkflowChatRoute
  '/_app/workflows': typeof AppWorkflowsRoute
  '/embed/dashboard': typeof EmbedDashboardRoute
  '/embed/folders': typeof EmbedFoldersRoute
  '/embed/requests': typeof EmbedRequestsRoute
  '/form-builder/$formId': typeof FormBuilderFormIdRoute
  '/on-boarding/$token': typeof OnBoardingTokenRoute
  '/portal/$portalId': typeof PortalPortalIdRoute
  '/portals_/$portalId': typeof PortalsPortalIdRoute
  '/sign-request/$': typeof SignRequestSplatRoute
  '/stories/Alert': typeof StoriesAlertRoute
  '/stories/accordion': typeof StoriesAccordionRoute
  '/stories/ai-icon': typeof StoriesAiIconRoute
  '/stories/avatar': typeof StoriesAvatarRoute
  '/stories/badge': typeof StoriesBadgeRoute
  '/stories/bar-loader': typeof StoriesBarLoaderRoute
  '/stories/button': typeof StoriesButtonRoute
  '/stories/card': typeof StoriesCardRoute
  '/stories/colors': typeof StoriesColorsRoute
  '/stories/data-table': typeof StoriesDataTableRoute
  '/stories/divider': typeof StoriesDividerRoute
  '/stories/drawer': typeof StoriesDrawerRoute
  '/stories/empty-state': typeof StoriesEmptyStateRoute
  '/stories/form': typeof StoriesFormRoute
  '/stories/highlight': typeof StoriesHighlightRoute
  '/stories/icon-button': typeof StoriesIconButtonRoute
  '/stories/indicator': typeof StoriesIndicatorRoute
  '/stories/input-checkbox': typeof StoriesInputCheckboxRoute
  '/stories/input-checkbox-card': typeof StoriesInputCheckboxCardRoute
  '/stories/input-checkbox-group': typeof StoriesInputCheckboxGroupRoute
  '/stories/input-date': typeof StoriesInputDateRoute
  '/stories/input-date-time': typeof StoriesInputDateTimeRoute
  '/stories/input-number': typeof StoriesInputNumberRoute
  '/stories/input-password': typeof StoriesInputPasswordRoute
  '/stories/input-pin': typeof StoriesInputPinRoute
  '/stories/input-radio': typeof StoriesInputRadioRoute
  '/stories/input-radio-card': typeof StoriesInputRadioCardRoute
  '/stories/input-radio-group': typeof StoriesInputRadioGroupRoute
  '/stories/input-select': typeof StoriesInputSelectRoute
  '/stories/input-select-multiple': typeof StoriesInputSelectMultipleRoute
  '/stories/input-switch': typeof StoriesInputSwitchRoute
  '/stories/input-switch-group': typeof StoriesInputSwitchGroupRoute
  '/stories/input-text': typeof StoriesInputTextRoute
  '/stories/input-textarea': typeof StoriesInputTextareaRoute
  '/stories/input-time': typeof StoriesInputTimeRoute
  '/stories/menu': typeof StoriesMenuRoute
  '/stories/modal': typeof StoriesModalRoute
  '/stories/pagination': typeof StoriesPaginationRoute
  '/stories/popover': typeof StoriesPopoverRoute
  '/stories/scroll-area': typeof StoriesScrollAreaRoute
  '/stories/skeleton': typeof StoriesSkeletonRoute
  '/stories/stepper': typeof StoriesStepperRoute
  '/stories/table': typeof StoriesTableRoute
  '/stories/tabs': typeof StoriesTabsRoute
  '/stories/toast': typeof StoriesToastRoute
  '/stories/tooltip': typeof StoriesTooltipRoute
  '/stories/typography': typeof StoriesTypographyRoute
  '/workflow-builder/$workflowId': typeof WorkflowBuilderWorkflowIdRoute
  '/_app/': typeof AppIndexRoute
  '/form-builder/': typeof FormBuilderIndexRoute
  '/on-boarding/': typeof OnBoardingIndexRoute
  '/stories/': typeof StoriesIndexRoute
  '/_app/my-account/{-$slug}': typeof AppMyAccountChar123SlugChar125Route
  '/_app/reports_/$reportId': typeof AppReportsReportIdRoute
  '/portals_/$tenantId/$portalId': typeof PortalsTenantIdPortalIdRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_auth/newuser/': typeof AuthNewuserIndexRoute
  '/_auth/recover/': typeof AuthRecoverIndexRoute
  '/_auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/_auth/setup/': typeof AuthSetupIndexRoute
  '/_auth/sign-in/': typeof AuthSignInIndexRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_app/forms_/$formId/entries': typeof AppFormsFormIdEntriesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/embed'
    | '/playground'
    | '/stories'
    | '/$encryptedName'
    | '/auth'
    | '/msal-redirect'
    | '/folders'
    | '/forms'
    | '/help-center'
    | '/mobile-preview'
    | '/portals'
    | '/reports'
    | '/requests'
    | '/search'
    | '/settings'
    | '/tasks'
    | '/trash'
    | '/workflow-chat'
    | '/workflows'
    | '/embed/dashboard'
    | '/embed/folders'
    | '/embed/requests'
    | '/form-builder/$formId'
    | '/on-boarding/$token'
    | '/portal/$portalId'
    | '/portals/$portalId'
    | '/sign-request/$'
    | '/stories/Alert'
    | '/stories/accordion'
    | '/stories/ai-icon'
    | '/stories/avatar'
    | '/stories/badge'
    | '/stories/bar-loader'
    | '/stories/button'
    | '/stories/card'
    | '/stories/colors'
    | '/stories/data-table'
    | '/stories/divider'
    | '/stories/drawer'
    | '/stories/empty-state'
    | '/stories/form'
    | '/stories/highlight'
    | '/stories/icon-button'
    | '/stories/indicator'
    | '/stories/input-checkbox'
    | '/stories/input-checkbox-card'
    | '/stories/input-checkbox-group'
    | '/stories/input-date'
    | '/stories/input-date-time'
    | '/stories/input-number'
    | '/stories/input-password'
    | '/stories/input-pin'
    | '/stories/input-radio'
    | '/stories/input-radio-card'
    | '/stories/input-radio-group'
    | '/stories/input-select'
    | '/stories/input-select-multiple'
    | '/stories/input-switch'
    | '/stories/input-switch-group'
    | '/stories/input-text'
    | '/stories/input-textarea'
    | '/stories/input-time'
    | '/stories/menu'
    | '/stories/modal'
    | '/stories/pagination'
    | '/stories/popover'
    | '/stories/scroll-area'
    | '/stories/skeleton'
    | '/stories/stepper'
    | '/stories/table'
    | '/stories/tabs'
    | '/stories/toast'
    | '/stories/tooltip'
    | '/stories/typography'
    | '/workflow-builder/$workflowId'
    | '/'
    | '/form-builder'
    | '/on-boarding'
    | '/stories/'
    | '/my-account/{-$slug}'
    | '/reports/$reportId'
    | '/portals/$tenantId/$portalId'
    | '/forgot-password'
    | '/login'
    | '/newuser'
    | '/recover'
    | '/reset-password'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/forms/$formId/entries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/embed'
    | '/playground'
    | '/$encryptedName'
    | '/auth'
    | '/msal-redirect'
    | '/folders'
    | '/forms'
    | '/help-center'
    | '/mobile-preview'
    | '/portals'
    | '/reports'
    | '/requests'
    | '/search'
    | '/settings'
    | '/tasks'
    | '/trash'
    | '/workflow-chat'
    | '/workflows'
    | '/embed/dashboard'
    | '/embed/folders'
    | '/embed/requests'
    | '/form-builder/$formId'
    | '/on-boarding/$token'
    | '/portal/$portalId'
    | '/portals/$portalId'
    | '/sign-request/$'
    | '/stories/Alert'
    | '/stories/accordion'
    | '/stories/ai-icon'
    | '/stories/avatar'
    | '/stories/badge'
    | '/stories/bar-loader'
    | '/stories/button'
    | '/stories/card'
    | '/stories/colors'
    | '/stories/data-table'
    | '/stories/divider'
    | '/stories/drawer'
    | '/stories/empty-state'
    | '/stories/form'
    | '/stories/highlight'
    | '/stories/icon-button'
    | '/stories/indicator'
    | '/stories/input-checkbox'
    | '/stories/input-checkbox-card'
    | '/stories/input-checkbox-group'
    | '/stories/input-date'
    | '/stories/input-date-time'
    | '/stories/input-number'
    | '/stories/input-password'
    | '/stories/input-pin'
    | '/stories/input-radio'
    | '/stories/input-radio-card'
    | '/stories/input-radio-group'
    | '/stories/input-select'
    | '/stories/input-select-multiple'
    | '/stories/input-switch'
    | '/stories/input-switch-group'
    | '/stories/input-text'
    | '/stories/input-textarea'
    | '/stories/input-time'
    | '/stories/menu'
    | '/stories/modal'
    | '/stories/pagination'
    | '/stories/popover'
    | '/stories/scroll-area'
    | '/stories/skeleton'
    | '/stories/stepper'
    | '/stories/table'
    | '/stories/tabs'
    | '/stories/toast'
    | '/stories/tooltip'
    | '/stories/typography'
    | '/workflow-builder/$workflowId'
    | '/'
    | '/form-builder'
    | '/on-boarding'
    | '/stories'
    | '/my-account/{-$slug}'
    | '/reports/$reportId'
    | '/portals/$tenantId/$portalId'
    | '/forgot-password'
    | '/login'
    | '/newuser'
    | '/recover'
    | '/reset-password'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/forms/$formId/entries'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/embed'
    | '/playground'
    | '/stories'
    | '/$encryptedName'
    | '/auth'
    | '/msal-redirect'
    | '/_app/folders'
    | '/_app/forms'
    | '/_app/help-center'
    | '/_app/mobile-preview'
    | '/_app/portals'
    | '/_app/reports'
    | '/_app/requests'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/trash'
    | '/_app/workflow-chat'
    | '/_app/workflows'
    | '/embed/dashboard'
    | '/embed/folders'
    | '/embed/requests'
    | '/form-builder/$formId'
    | '/on-boarding/$token'
    | '/portal/$portalId'
    | '/portals_/$portalId'
    | '/sign-request/$'
    | '/stories/Alert'
    | '/stories/accordion'
    | '/stories/ai-icon'
    | '/stories/avatar'
    | '/stories/badge'
    | '/stories/bar-loader'
    | '/stories/button'
    | '/stories/card'
    | '/stories/colors'
    | '/stories/data-table'
    | '/stories/divider'
    | '/stories/drawer'
    | '/stories/empty-state'
    | '/stories/form'
    | '/stories/highlight'
    | '/stories/icon-button'
    | '/stories/indicator'
    | '/stories/input-checkbox'
    | '/stories/input-checkbox-card'
    | '/stories/input-checkbox-group'
    | '/stories/input-date'
    | '/stories/input-date-time'
    | '/stories/input-number'
    | '/stories/input-password'
    | '/stories/input-pin'
    | '/stories/input-radio'
    | '/stories/input-radio-card'
    | '/stories/input-radio-group'
    | '/stories/input-select'
    | '/stories/input-select-multiple'
    | '/stories/input-switch'
    | '/stories/input-switch-group'
    | '/stories/input-text'
    | '/stories/input-textarea'
    | '/stories/input-time'
    | '/stories/menu'
    | '/stories/modal'
    | '/stories/pagination'
    | '/stories/popover'
    | '/stories/scroll-area'
    | '/stories/skeleton'
    | '/stories/stepper'
    | '/stories/table'
    | '/stories/tabs'
    | '/stories/toast'
    | '/stories/tooltip'
    | '/stories/typography'
    | '/workflow-builder/$workflowId'
    | '/_app/'
    | '/form-builder/'
    | '/on-boarding/'
    | '/stories/'
    | '/_app/my-account/{-$slug}'
    | '/_app/reports_/$reportId'
    | '/portals_/$tenantId/$portalId'
    | '/_auth/forgot-password/'
    | '/_auth/login/'
    | '/_auth/newuser/'
    | '/_auth/recover/'
    | '/_auth/reset-password/'
    | '/_auth/setup/'
    | '/_auth/sign-in/'
    | '/_auth/sign-up/'
    | '/_app/forms_/$formId/entries'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  EmbedRouteRoute: typeof EmbedRouteRouteWithChildren
  PlaygroundRouteRoute: typeof PlaygroundRouteRoute
  StoriesRouteRoute: typeof StoriesRouteRouteWithChildren
  EncryptedNameRoute: typeof EncryptedNameRoute
  AuthRoute: typeof AuthRoute
  MsalRedirectRoute: typeof MsalRedirectRoute
  FormBuilderFormIdRoute: typeof FormBuilderFormIdRoute
  OnBoardingTokenRoute: typeof OnBoardingTokenRoute
  PortalPortalIdRoute: typeof PortalPortalIdRoute
  PortalsPortalIdRoute: typeof PortalsPortalIdRoute
  SignRequestSplatRoute: typeof SignRequestSplatRoute
  WorkflowBuilderWorkflowIdRoute: typeof WorkflowBuilderWorkflowIdRoute
  FormBuilderIndexRoute: typeof FormBuilderIndexRoute
  OnBoardingIndexRoute: typeof OnBoardingIndexRoute
  PortalsTenantIdPortalIdRoute: typeof PortalsTenantIdPortalIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/msal-redirect': {
      id: '/msal-redirect'
      path: '/msal-redirect'
      fullPath: '/msal-redirect'
      preLoaderRoute: typeof MsalRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$encryptedName': {
      id: '/$encryptedName'
      path: '/$encryptedName'
      fullPath: '/$encryptedName'
      preLoaderRoute: typeof EncryptedNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stories': {
      id: '/stories'
      path: '/stories'
      fullPath: '/stories'
      preLoaderRoute: typeof StoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed': {
      id: '/embed'
      path: '/embed'
      fullPath: '/embed'
      preLoaderRoute: typeof EmbedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stories/': {
      id: '/stories/'
      path: '/'
      fullPath: '/stories/'
      preLoaderRoute: typeof StoriesIndexRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/on-boarding/': {
      id: '/on-boarding/'
      path: '/on-boarding'
      fullPath: '/on-boarding'
      preLoaderRoute: typeof OnBoardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/': {
      id: '/form-builder/'
      path: '/form-builder'
      fullPath: '/form-builder'
      preLoaderRoute: typeof FormBuilderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/workflow-builder/$workflowId': {
      id: '/workflow-builder/$workflowId'
      path: '/workflow-builder/$workflowId'
      fullPath: '/workflow-builder/$workflowId'
      preLoaderRoute: typeof WorkflowBuilderWorkflowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stories/typography': {
      id: '/stories/typography'
      path: '/typography'
      fullPath: '/stories/typography'
      preLoaderRoute: typeof StoriesTypographyRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/tooltip': {
      id: '/stories/tooltip'
      path: '/tooltip'
      fullPath: '/stories/tooltip'
      preLoaderRoute: typeof StoriesTooltipRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/toast': {
      id: '/stories/toast'
      path: '/toast'
      fullPath: '/stories/toast'
      preLoaderRoute: typeof StoriesToastRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/tabs': {
      id: '/stories/tabs'
      path: '/tabs'
      fullPath: '/stories/tabs'
      preLoaderRoute: typeof StoriesTabsRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/table': {
      id: '/stories/table'
      path: '/table'
      fullPath: '/stories/table'
      preLoaderRoute: typeof StoriesTableRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/stepper': {
      id: '/stories/stepper'
      path: '/stepper'
      fullPath: '/stories/stepper'
      preLoaderRoute: typeof StoriesStepperRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/skeleton': {
      id: '/stories/skeleton'
      path: '/skeleton'
      fullPath: '/stories/skeleton'
      preLoaderRoute: typeof StoriesSkeletonRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/scroll-area': {
      id: '/stories/scroll-area'
      path: '/scroll-area'
      fullPath: '/stories/scroll-area'
      preLoaderRoute: typeof StoriesScrollAreaRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/popover': {
      id: '/stories/popover'
      path: '/popover'
      fullPath: '/stories/popover'
      preLoaderRoute: typeof StoriesPopoverRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/pagination': {
      id: '/stories/pagination'
      path: '/pagination'
      fullPath: '/stories/pagination'
      preLoaderRoute: typeof StoriesPaginationRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/modal': {
      id: '/stories/modal'
      path: '/modal'
      fullPath: '/stories/modal'
      preLoaderRoute: typeof StoriesModalRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/menu': {
      id: '/stories/menu'
      path: '/menu'
      fullPath: '/stories/menu'
      preLoaderRoute: typeof StoriesMenuRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-time': {
      id: '/stories/input-time'
      path: '/input-time'
      fullPath: '/stories/input-time'
      preLoaderRoute: typeof StoriesInputTimeRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-textarea': {
      id: '/stories/input-textarea'
      path: '/input-textarea'
      fullPath: '/stories/input-textarea'
      preLoaderRoute: typeof StoriesInputTextareaRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-text': {
      id: '/stories/input-text'
      path: '/input-text'
      fullPath: '/stories/input-text'
      preLoaderRoute: typeof StoriesInputTextRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-switch-group': {
      id: '/stories/input-switch-group'
      path: '/input-switch-group'
      fullPath: '/stories/input-switch-group'
      preLoaderRoute: typeof StoriesInputSwitchGroupRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-switch': {
      id: '/stories/input-switch'
      path: '/input-switch'
      fullPath: '/stories/input-switch'
      preLoaderRoute: typeof StoriesInputSwitchRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-select-multiple': {
      id: '/stories/input-select-multiple'
      path: '/input-select-multiple'
      fullPath: '/stories/input-select-multiple'
      preLoaderRoute: typeof StoriesInputSelectMultipleRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-select': {
      id: '/stories/input-select'
      path: '/input-select'
      fullPath: '/stories/input-select'
      preLoaderRoute: typeof StoriesInputSelectRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-radio-group': {
      id: '/stories/input-radio-group'
      path: '/input-radio-group'
      fullPath: '/stories/input-radio-group'
      preLoaderRoute: typeof StoriesInputRadioGroupRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-radio-card': {
      id: '/stories/input-radio-card'
      path: '/input-radio-card'
      fullPath: '/stories/input-radio-card'
      preLoaderRoute: typeof StoriesInputRadioCardRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-radio': {
      id: '/stories/input-radio'
      path: '/input-radio'
      fullPath: '/stories/input-radio'
      preLoaderRoute: typeof StoriesInputRadioRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-pin': {
      id: '/stories/input-pin'
      path: '/input-pin'
      fullPath: '/stories/input-pin'
      preLoaderRoute: typeof StoriesInputPinRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-password': {
      id: '/stories/input-password'
      path: '/input-password'
      fullPath: '/stories/input-password'
      preLoaderRoute: typeof StoriesInputPasswordRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-number': {
      id: '/stories/input-number'
      path: '/input-number'
      fullPath: '/stories/input-number'
      preLoaderRoute: typeof StoriesInputNumberRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-date-time': {
      id: '/stories/input-date-time'
      path: '/input-date-time'
      fullPath: '/stories/input-date-time'
      preLoaderRoute: typeof StoriesInputDateTimeRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-date': {
      id: '/stories/input-date'
      path: '/input-date'
      fullPath: '/stories/input-date'
      preLoaderRoute: typeof StoriesInputDateRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-checkbox-group': {
      id: '/stories/input-checkbox-group'
      path: '/input-checkbox-group'
      fullPath: '/stories/input-checkbox-group'
      preLoaderRoute: typeof StoriesInputCheckboxGroupRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-checkbox-card': {
      id: '/stories/input-checkbox-card'
      path: '/input-checkbox-card'
      fullPath: '/stories/input-checkbox-card'
      preLoaderRoute: typeof StoriesInputCheckboxCardRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/input-checkbox': {
      id: '/stories/input-checkbox'
      path: '/input-checkbox'
      fullPath: '/stories/input-checkbox'
      preLoaderRoute: typeof StoriesInputCheckboxRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/indicator': {
      id: '/stories/indicator'
      path: '/indicator'
      fullPath: '/stories/indicator'
      preLoaderRoute: typeof StoriesIndicatorRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/icon-button': {
      id: '/stories/icon-button'
      path: '/icon-button'
      fullPath: '/stories/icon-button'
      preLoaderRoute: typeof StoriesIconButtonRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/highlight': {
      id: '/stories/highlight'
      path: '/highlight'
      fullPath: '/stories/highlight'
      preLoaderRoute: typeof StoriesHighlightRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/form': {
      id: '/stories/form'
      path: '/form'
      fullPath: '/stories/form'
      preLoaderRoute: typeof StoriesFormRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/empty-state': {
      id: '/stories/empty-state'
      path: '/empty-state'
      fullPath: '/stories/empty-state'
      preLoaderRoute: typeof StoriesEmptyStateRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/drawer': {
      id: '/stories/drawer'
      path: '/drawer'
      fullPath: '/stories/drawer'
      preLoaderRoute: typeof StoriesDrawerRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/divider': {
      id: '/stories/divider'
      path: '/divider'
      fullPath: '/stories/divider'
      preLoaderRoute: typeof StoriesDividerRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/data-table': {
      id: '/stories/data-table'
      path: '/data-table'
      fullPath: '/stories/data-table'
      preLoaderRoute: typeof StoriesDataTableRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/colors': {
      id: '/stories/colors'
      path: '/colors'
      fullPath: '/stories/colors'
      preLoaderRoute: typeof StoriesColorsRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/card': {
      id: '/stories/card'
      path: '/card'
      fullPath: '/stories/card'
      preLoaderRoute: typeof StoriesCardRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/button': {
      id: '/stories/button'
      path: '/button'
      fullPath: '/stories/button'
      preLoaderRoute: typeof StoriesButtonRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/bar-loader': {
      id: '/stories/bar-loader'
      path: '/bar-loader'
      fullPath: '/stories/bar-loader'
      preLoaderRoute: typeof StoriesBarLoaderRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/badge': {
      id: '/stories/badge'
      path: '/badge'
      fullPath: '/stories/badge'
      preLoaderRoute: typeof StoriesBadgeRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/avatar': {
      id: '/stories/avatar'
      path: '/avatar'
      fullPath: '/stories/avatar'
      preLoaderRoute: typeof StoriesAvatarRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/ai-icon': {
      id: '/stories/ai-icon'
      path: '/ai-icon'
      fullPath: '/stories/ai-icon'
      preLoaderRoute: typeof StoriesAiIconRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/accordion': {
      id: '/stories/accordion'
      path: '/accordion'
      fullPath: '/stories/accordion'
      preLoaderRoute: typeof StoriesAccordionRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/stories/Alert': {
      id: '/stories/Alert'
      path: '/Alert'
      fullPath: '/stories/Alert'
      preLoaderRoute: typeof StoriesAlertRouteImport
      parentRoute: typeof StoriesRouteRoute
    }
    '/sign-request/$': {
      id: '/sign-request/$'
      path: '/sign-request/$'
      fullPath: '/sign-request/$'
      preLoaderRoute: typeof SignRequestSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portals_/$portalId': {
      id: '/portals_/$portalId'
      path: '/portals/$portalId'
      fullPath: '/portals/$portalId'
      preLoaderRoute: typeof PortalsPortalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/$portalId': {
      id: '/portal/$portalId'
      path: '/portal/$portalId'
      fullPath: '/portal/$portalId'
      preLoaderRoute: typeof PortalPortalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/on-boarding/$token': {
      id: '/on-boarding/$token'
      path: '/on-boarding/$token'
      fullPath: '/on-boarding/$token'
      preLoaderRoute: typeof OnBoardingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-builder/$formId': {
      id: '/form-builder/$formId'
      path: '/form-builder/$formId'
      fullPath: '/form-builder/$formId'
      preLoaderRoute: typeof FormBuilderFormIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/requests': {
      id: '/embed/requests'
      path: '/requests'
      fullPath: '/embed/requests'
      preLoaderRoute: typeof EmbedRequestsRouteImport
      parentRoute: typeof EmbedRouteRoute
    }
    '/embed/folders': {
      id: '/embed/folders'
      path: '/folders'
      fullPath: '/embed/folders'
      preLoaderRoute: typeof EmbedFoldersRouteImport
      parentRoute: typeof EmbedRouteRoute
    }
    '/embed/dashboard': {
      id: '/embed/dashboard'
      path: '/dashboard'
      fullPath: '/embed/dashboard'
      preLoaderRoute: typeof EmbedDashboardRouteImport
      parentRoute: typeof EmbedRouteRoute
    }
    '/_app/workflows': {
      id: '/_app/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AppWorkflowsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/workflow-chat': {
      id: '/_app/workflow-chat'
      path: '/workflow-chat'
      fullPath: '/workflow-chat'
      preLoaderRoute: typeof AppWorkflowChatRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/requests': {
      id: '/_app/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AppRequestsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/portals': {
      id: '/_app/portals'
      path: '/portals'
      fullPath: '/portals'
      preLoaderRoute: typeof AppPortalsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/mobile-preview': {
      id: '/_app/mobile-preview'
      path: '/mobile-preview'
      fullPath: '/mobile-preview'
      preLoaderRoute: typeof AppMobilePreviewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/help-center': {
      id: '/_app/help-center'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AppHelpCenterRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/forms': {
      id: '/_app/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AppFormsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/folders': {
      id: '/_app/folders'
      path: '/folders'
      fullPath: '/folders'
      preLoaderRoute: typeof AppFoldersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in/': {
      id: '/_auth/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/setup/': {
      id: '/_auth/setup/'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthSetupIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reset-password/': {
      id: '/_auth/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/recover/': {
      id: '/_auth/recover/'
      path: '/recover'
      fullPath: '/recover'
      preLoaderRoute: typeof AuthRecoverIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/newuser/': {
      id: '/_auth/newuser/'
      path: '/newuser'
      fullPath: '/newuser'
      preLoaderRoute: typeof AuthNewuserIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/portals_/$tenantId/$portalId': {
      id: '/portals_/$tenantId/$portalId'
      path: '/portals/$tenantId/$portalId'
      fullPath: '/portals/$tenantId/$portalId'
      preLoaderRoute: typeof PortalsTenantIdPortalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/reports_/$reportId': {
      id: '/_app/reports_/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AppReportsReportIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/my-account/{-$slug}': {
      id: '/_app/my-account/{-$slug}'
      path: '/my-account/{-$slug}'
      fullPath: '/my-account/{-$slug}'
      preLoaderRoute: typeof AppMyAccountChar123SlugChar125RouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/forms_/$formId/entries': {
      id: '/_app/forms_/$formId/entries'
      path: '/forms/$formId/entries'
      fullPath: '/forms/$formId/entries'
      preLoaderRoute: typeof AppFormsFormIdEntriesRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppFoldersRoute: typeof AppFoldersRoute
  AppFormsRoute: typeof AppFormsRoute
  AppHelpCenterRoute: typeof AppHelpCenterRoute
  AppMobilePreviewRoute: typeof AppMobilePreviewRoute
  AppPortalsRoute: typeof AppPortalsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppRequestsRoute: typeof AppRequestsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTrashRoute: typeof AppTrashRoute
  AppWorkflowChatRoute: typeof AppWorkflowChatRoute
  AppWorkflowsRoute: typeof AppWorkflowsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMyAccountChar123SlugChar125Route: typeof AppMyAccountChar123SlugChar125Route
  AppReportsReportIdRoute: typeof AppReportsReportIdRoute
  AppFormsFormIdEntriesRoute: typeof AppFormsFormIdEntriesRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppFoldersRoute: AppFoldersRoute,
  AppFormsRoute: AppFormsRoute,
  AppHelpCenterRoute: AppHelpCenterRoute,
  AppMobilePreviewRoute: AppMobilePreviewRoute,
  AppPortalsRoute: AppPortalsRoute,
  AppReportsRoute: AppReportsRoute,
  AppRequestsRoute: AppRequestsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTrashRoute: AppTrashRoute,
  AppWorkflowChatRoute: AppWorkflowChatRoute,
  AppWorkflowsRoute: AppWorkflowsRoute,
  AppIndexRoute: AppIndexRoute,
  AppMyAccountChar123SlugChar125Route: AppMyAccountChar123SlugChar125Route,
  AppReportsReportIdRoute: AppReportsReportIdRoute,
  AppFormsFormIdEntriesRoute: AppFormsFormIdEntriesRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthNewuserIndexRoute: typeof AuthNewuserIndexRoute
  AuthRecoverIndexRoute: typeof AuthRecoverIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthSetupIndexRoute: typeof AuthSetupIndexRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthNewuserIndexRoute: AuthNewuserIndexRoute,
  AuthRecoverIndexRoute: AuthRecoverIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthSetupIndexRoute: AuthSetupIndexRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface EmbedRouteRouteChildren {
  EmbedDashboardRoute: typeof EmbedDashboardRoute
  EmbedFoldersRoute: typeof EmbedFoldersRoute
  EmbedRequestsRoute: typeof EmbedRequestsRoute
}

const EmbedRouteRouteChildren: EmbedRouteRouteChildren = {
  EmbedDashboardRoute: EmbedDashboardRoute,
  EmbedFoldersRoute: EmbedFoldersRoute,
  EmbedRequestsRoute: EmbedRequestsRoute,
}

const EmbedRouteRouteWithChildren = EmbedRouteRoute._addFileChildren(
  EmbedRouteRouteChildren,
)

interface StoriesRouteRouteChildren {
  StoriesAlertRoute: typeof StoriesAlertRoute
  StoriesAccordionRoute: typeof StoriesAccordionRoute
  StoriesAiIconRoute: typeof StoriesAiIconRoute
  StoriesAvatarRoute: typeof StoriesAvatarRoute
  StoriesBadgeRoute: typeof StoriesBadgeRoute
  StoriesBarLoaderRoute: typeof StoriesBarLoaderRoute
  StoriesButtonRoute: typeof StoriesButtonRoute
  StoriesCardRoute: typeof StoriesCardRoute
  StoriesColorsRoute: typeof StoriesColorsRoute
  StoriesDataTableRoute: typeof StoriesDataTableRoute
  StoriesDividerRoute: typeof StoriesDividerRoute
  StoriesDrawerRoute: typeof StoriesDrawerRoute
  StoriesEmptyStateRoute: typeof StoriesEmptyStateRoute
  StoriesFormRoute: typeof StoriesFormRoute
  StoriesHighlightRoute: typeof StoriesHighlightRoute
  StoriesIconButtonRoute: typeof StoriesIconButtonRoute
  StoriesIndicatorRoute: typeof StoriesIndicatorRoute
  StoriesInputCheckboxRoute: typeof StoriesInputCheckboxRoute
  StoriesInputCheckboxCardRoute: typeof StoriesInputCheckboxCardRoute
  StoriesInputCheckboxGroupRoute: typeof StoriesInputCheckboxGroupRoute
  StoriesInputDateRoute: typeof StoriesInputDateRoute
  StoriesInputDateTimeRoute: typeof StoriesInputDateTimeRoute
  StoriesInputNumberRoute: typeof StoriesInputNumberRoute
  StoriesInputPasswordRoute: typeof StoriesInputPasswordRoute
  StoriesInputPinRoute: typeof StoriesInputPinRoute
  StoriesInputRadioRoute: typeof StoriesInputRadioRoute
  StoriesInputRadioCardRoute: typeof StoriesInputRadioCardRoute
  StoriesInputRadioGroupRoute: typeof StoriesInputRadioGroupRoute
  StoriesInputSelectRoute: typeof StoriesInputSelectRoute
  StoriesInputSelectMultipleRoute: typeof StoriesInputSelectMultipleRoute
  StoriesInputSwitchRoute: typeof StoriesInputSwitchRoute
  StoriesInputSwitchGroupRoute: typeof StoriesInputSwitchGroupRoute
  StoriesInputTextRoute: typeof StoriesInputTextRoute
  StoriesInputTextareaRoute: typeof StoriesInputTextareaRoute
  StoriesInputTimeRoute: typeof StoriesInputTimeRoute
  StoriesMenuRoute: typeof StoriesMenuRoute
  StoriesModalRoute: typeof StoriesModalRoute
  StoriesPaginationRoute: typeof StoriesPaginationRoute
  StoriesPopoverRoute: typeof StoriesPopoverRoute
  StoriesScrollAreaRoute: typeof StoriesScrollAreaRoute
  StoriesSkeletonRoute: typeof StoriesSkeletonRoute
  StoriesStepperRoute: typeof StoriesStepperRoute
  StoriesTableRoute: typeof StoriesTableRoute
  StoriesTabsRoute: typeof StoriesTabsRoute
  StoriesToastRoute: typeof StoriesToastRoute
  StoriesTooltipRoute: typeof StoriesTooltipRoute
  StoriesTypographyRoute: typeof StoriesTypographyRoute
  StoriesIndexRoute: typeof StoriesIndexRoute
}

const StoriesRouteRouteChildren: StoriesRouteRouteChildren = {
  StoriesAlertRoute: StoriesAlertRoute,
  StoriesAccordionRoute: StoriesAccordionRoute,
  StoriesAiIconRoute: StoriesAiIconRoute,
  StoriesAvatarRoute: StoriesAvatarRoute,
  StoriesBadgeRoute: StoriesBadgeRoute,
  StoriesBarLoaderRoute: StoriesBarLoaderRoute,
  StoriesButtonRoute: StoriesButtonRoute,
  StoriesCardRoute: StoriesCardRoute,
  StoriesColorsRoute: StoriesColorsRoute,
  StoriesDataTableRoute: StoriesDataTableRoute,
  StoriesDividerRoute: StoriesDividerRoute,
  StoriesDrawerRoute: StoriesDrawerRoute,
  StoriesEmptyStateRoute: StoriesEmptyStateRoute,
  StoriesFormRoute: StoriesFormRoute,
  StoriesHighlightRoute: StoriesHighlightRoute,
  StoriesIconButtonRoute: StoriesIconButtonRoute,
  StoriesIndicatorRoute: StoriesIndicatorRoute,
  StoriesInputCheckboxRoute: StoriesInputCheckboxRoute,
  StoriesInputCheckboxCardRoute: StoriesInputCheckboxCardRoute,
  StoriesInputCheckboxGroupRoute: StoriesInputCheckboxGroupRoute,
  StoriesInputDateRoute: StoriesInputDateRoute,
  StoriesInputDateTimeRoute: StoriesInputDateTimeRoute,
  StoriesInputNumberRoute: StoriesInputNumberRoute,
  StoriesInputPasswordRoute: StoriesInputPasswordRoute,
  StoriesInputPinRoute: StoriesInputPinRoute,
  StoriesInputRadioRoute: StoriesInputRadioRoute,
  StoriesInputRadioCardRoute: StoriesInputRadioCardRoute,
  StoriesInputRadioGroupRoute: StoriesInputRadioGroupRoute,
  StoriesInputSelectRoute: StoriesInputSelectRoute,
  StoriesInputSelectMultipleRoute: StoriesInputSelectMultipleRoute,
  StoriesInputSwitchRoute: StoriesInputSwitchRoute,
  StoriesInputSwitchGroupRoute: StoriesInputSwitchGroupRoute,
  StoriesInputTextRoute: StoriesInputTextRoute,
  StoriesInputTextareaRoute: StoriesInputTextareaRoute,
  StoriesInputTimeRoute: StoriesInputTimeRoute,
  StoriesMenuRoute: StoriesMenuRoute,
  StoriesModalRoute: StoriesModalRoute,
  StoriesPaginationRoute: StoriesPaginationRoute,
  StoriesPopoverRoute: StoriesPopoverRoute,
  StoriesScrollAreaRoute: StoriesScrollAreaRoute,
  StoriesSkeletonRoute: StoriesSkeletonRoute,
  StoriesStepperRoute: StoriesStepperRoute,
  StoriesTableRoute: StoriesTableRoute,
  StoriesTabsRoute: StoriesTabsRoute,
  StoriesToastRoute: StoriesToastRoute,
  StoriesTooltipRoute: StoriesTooltipRoute,
  StoriesTypographyRoute: StoriesTypographyRoute,
  StoriesIndexRoute: StoriesIndexRoute,
}

const StoriesRouteRouteWithChildren = StoriesRouteRoute._addFileChildren(
  StoriesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  EmbedRouteRoute: EmbedRouteRouteWithChildren,
  PlaygroundRouteRoute: PlaygroundRouteRoute,
  StoriesRouteRoute: StoriesRouteRouteWithChildren,
  EncryptedNameRoute: EncryptedNameRoute,
  AuthRoute: AuthRoute,
  MsalRedirectRoute: MsalRedirectRoute,
  FormBuilderFormIdRoute: FormBuilderFormIdRoute,
  OnBoardingTokenRoute: OnBoardingTokenRoute,
  PortalPortalIdRoute: PortalPortalIdRoute,
  PortalsPortalIdRoute: PortalsPortalIdRoute,
  SignRequestSplatRoute: SignRequestSplatRoute,
  WorkflowBuilderWorkflowIdRoute: WorkflowBuilderWorkflowIdRoute,
  FormBuilderIndexRoute: FormBuilderIndexRoute,
  OnBoardingIndexRoute: OnBoardingIndexRoute,
  PortalsTenantIdPortalIdRoute: PortalsTenantIdPortalIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
